import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Global CSS reset import. Required.
import "./index.css";

import { AppStoreProvider } from "./common";

const app = createRoot(document.getElementById("app") as HTMLElement);
app.render(
  <AppStoreProvider>
    <App />
  </AppStoreProvider>,
);
